import api from './utils/api';

class PlansService {
  async listPlans() {
    const { data } = await api.get('/plans');

    // Garantir que sempre retorna um array
    if (Array.isArray(data)) {
      return data;
    }

    // Se a API retornar { plan: [...] } ou { plans: [...] }
    if (data && Array.isArray(data.plan)) {
      return data.plan;
    }

    if (data && Array.isArray(data.plans)) {
      return data.plans;
    }

    console.error('PlansService: API retornou formato inesperado:', data);
    return [];
  }

  async findById(id) {
    const result = await api.get(`/plans/${id}`);
    return result.data;
  }

  async update(id, data) {
    const result = await api.put(`/plans/${id}`, data);
    return result.data;
  }
}

export default new PlansService();
